/**
 * Verlustfreie Fehlertexte fuer die Oberflaeche.
 *
 * Supabase wirft KEINE Error-Instanzen, sondern schlichte Objekte
 * ({ message, details, hint, code }). Das verbreitete Muster
 * `e instanceof Error ? e.message : String(e)` macht daraus "[object Object]"
 * und vernichtet damit genau die Information, die den Fehler erklaert.
 * describeError() holt Message, Details, Hinweis und Code heraus und faellt
 * zur Not auf JSON zurueck – aber nie auf "[object Object]".
 */
export const describeError = (e: unknown): string => {
    if (e === null || e === undefined) return 'Unbekannter Fehler';
    if (typeof e === 'string') return e || 'Unbekannter Fehler';
    if (e instanceof Error) return e.message || e.name || 'Unbekannter Fehler';
    if (typeof e !== 'object') return String(e);

    const err = e as Record<string, unknown>;
    const str = (v: unknown): string => (typeof v === 'string' ? v.trim() : v == null ? '' : String(v));

    const message = str(err.message) || str(err.error_description) || str(err.error);
    // Zusatzfelder eines PostgrestError – ohne sie bleiben RLS- und
    // Constraint-Verletzungen praktisch nicht diagnostizierbar.
    const extras = [
        str(err.details) && `Details: ${str(err.details)}`,
        str(err.hint) && `Hinweis: ${str(err.hint)}`,
        str(err.code) && `Code: ${str(err.code)}`,
    ].filter(Boolean);

    if (message) return extras.length ? `${message} (${extras.join(', ')})` : message;

    // Kein message-Feld: lieber die rohe Struktur zeigen als "[object Object]".
    try {
        const json = JSON.stringify(e);
        if (json && json !== '{}') return json;
    } catch {
        // Zirkulaere Struktur – Feldnamen sind immer noch besser als nichts.
    }
    const keys = Object.keys(err);
    return keys.length ? `Unbekannter Fehler (Felder: ${keys.join(', ')})` : 'Unbekannter Fehler';
};
